import React from 'react';
import {SDDwellingData} from "./SDDwellingData";
import ViewDataContextProvider from "../../commons/context/view/ViewDataContext.js";
import FiltersDataContextProvider from "../../commons/context/FiltersDataContext";
import FiltersStateContextProvider from '../../commons/context/FiltersStateContext';

const SDDwellingView = (props) => {

    return (
        <FiltersDataContextProvider>
            <FiltersStateContextProvider context = {props.match.params.context}>
                <ViewDataContextProvider>
                    <SDDwellingData/>
                </ViewDataContextProvider>
            </FiltersStateContextProvider>
        </FiltersDataContextProvider>

    )
}

export default SDDwellingView;


// WEBPACK FOOTER //
// ./src/components/sdDwelling/SDDwellingView.js